module.exports = __webpack_public_path__ + "static/media/productos.f47892b3.svg";